import babelPolyfill from 'babel-polyfill';
import Vue from 'vue';
import VModal from 'vue-js-modal';
import VueScrollTo from 'vue-scrollto';
import makeStore from '@/store';
import App from '@/App.vue';
import router from '@/router';
import '@/filters';
import '@/helpers';
import '@/directives';
import '@/hotjar';
import '@/tracking';
import apiServices from '@/services';


Vue.config.productionTip = false;
Vue.use(VModal);
Vue.use(VueScrollTo);

const store = makeStore(apiServices);

new Vue({
  store,
  router,
  apiServices,
  render: h => h(App),
}).$mount('#app');
